export function parse(csv) {
  // Split csv string into rows array
  let rows = [];
  if (csv.search("\r\n") > -1) {
    rows = csv.split("\r\n");
  } else {
    rows = csv.split("\n");
  }
  // Split rows string into columns array
  return rows.map(row => {
    let cols = [];
    let col = "";
    let insideQuote = false;
    console.log(row);
    for (let i = 0; i < row.length; i++) {
      let char = row.charAt(i);
      // If delimiter OR end
      if ((!insideQuote && char == ",") || i == row.length - 1) {
        // Build column
        if (![",", '"'].includes(char)) {
          col += char;
        }
        console.log(col);
        cols.push(col);
        col = "";
      }
      // If start/end " (OR not inside ")
      if (char == '"' && row.charAt(i + 1) != '"') {
        insideQuote = !insideQuote;
        continue;
      }
      // If inside "
      if (char == '"' && row.charAt(i + 1) == '"') {
        // Replace with '
        char = "'";
        // Skip next quote
        i++;
      }
      // Build column
      if (insideQuote || ![",", '"'].includes(char)) {
        col += char;
      }
    }
    return cols;
  });
}



// WEBPACK FOOTER //
// ./src/helpers/csv-parser.js